// client_patch.js, For Android 4.0
// https://github.com/facebook/create-react-app/issues/2602
// __esModule 报错 所以添加的 2021-04-08
let defineProperty = Object.defineProperty;
Object.defineProperty = function (exports, name) {
  if (name === '__esModule') {
    exports[name] = true;
    return;
  }
  return defineProperty.apply(this, arguments);
}



//////////////////
// WEBPACK FOOTER
// ./build/client.js
// module id = Sa0o
// module chunks = 11